export const GET_DEALS_API = 'GET_DEALS_API';
export const GET_DEALS_API_SUCCESS = 'GET_DEALS_API_SUCCESS';
export const GET_DEALS_API_ERROR = 'GET_DEALS_API_ERROR';

export const GET_DEAL_API = 'GET_DEAL_API';